<script setup>
import {computed} from "vue";

const model = defineModel({
  type: [Boolean],
  required: false,
  default: false,
});

const props = defineProps({
  trueValue: {
    type: Boolean,
    default: true,
  },
});

const classMap = computed(() => model.value !== props.trueValue ? 'tw-border-[#15232B]' : 'tw-border-primary');
</script>

<template>
  <span
    class="tw-flex tw-justify-center tw-items-center tw-h-6 tw-w-6 tw-border-2 tw-rounded-full tw-bg-white tw-cursor-pointer"
    :class="classMap"
    @click.stop="model = !model"
  >
    <svg-vue
      v-if="model === trueValue"
      icon="icons/check"
      class="tw-w-4 tw-h-4 tw-text-primary"
    />
  </span>
</template>
